/* eslint-disable array-callback-return, consistent-return */
import React from 'react';
import PropTypes from 'prop-types';

const FiniteScrollTopStories = ({ articles }) => {
  if (!articles) return false;

  return (
    <section className="finite-scroll__top-stories">
      <div className="finite-scroll__header">Today{"'"}s Top Stories:</div>
      <div className="articles">
        {articles.map((article, idx) => (
          <article key={`article-${idx}`}>
            <div className="rank">0{idx + 1}</div>

            <div className="image">
              <a href={article.url}>
                <img src={article.image_url.replace('.png','.webp').replace('.jpg','.webp').replace('.gif','.webp').replace('w_1280','w_220')} alt={article.title} />
              </a>
            </div>

            <div className="hed">
              <div className="eyebrow">{article.section}</div>

              <a href={article.url}>{article.title}</a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

FiniteScrollTopStories.propTypes = {
  articles: PropTypes.shape([])
};

FiniteScrollTopStories.defaultProps = {
  articles: null
};

export default FiniteScrollTopStories;
